<template>
  <div>
    <Vertical v-if="layoutType === 'vertical'" :layout="layoutType">
      <template #header-container>
        <div class="header-container" ref="header-container">
          <slot name="header-container" />
        </div>
      </template>
      <div class="container-fluid">
        <slot />
      </div>
    </Vertical>

    <Horizontal v-if="layoutType === 'horizontal'" :layout="layoutType">
      <slot />
    </Horizontal>
  </div>
</template>

<script>
import { layoutComputed } from '@/state/helpers'
import Vertical from './components/Vertical'
import Horizontal from './components/Horizontal'
import { MixPanel } from '@/mixin/mixpanel'

export default {
  name: 'LayoutMain',
  components: {
    Vertical,
    Horizontal,
  },
  mixins: [MixPanel],
  data() {
    return {}
  },
  computed: {
    ...layoutComputed,
  },
  mounted() {
    // document.querySelector("html").setAttribute('dir', 'rtl');
    let lastPage = window.history.state
    window.addEventListener('popstate', (event) => {
      const currentPage = event.state

      if (lastPage !== null && Number(lastPage.key) > Number(currentPage.key)) {
        this.track('Browser Back Button')
      }

      lastPage = currentPage
    })
    if (!lastPage) {
      history.replaceState(1, null)
      lastPage = 1
    }
    document.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      const scrollY = window.scrollY
      this.$refs['header-container'].style.backgroundColor = scrollY >= 24 ? 'white' : 'inherit'
    },
  },
}
</script>

<style scoped lang="scss">
.header-container {
  position: sticky;
  top: 70px;
  z-index: 115;
}
</style>
